// 作废协议组件
<template>
<div class="contract-root">
  <h1>作废协议</h1>
  <!-- simpleChineseNumbers -->
  <p v-for="(signator,i) of INVALI.signInfoVOS" :key="signator.i">{{`签约方${simpleChineseNumbers[i+1]}:&nbsp;&nbsp;${signator.signatoryFullName.split('-')[0] || ''}`}}</p>
  <p class="indent">鉴于以上签约方于{{moment(INVALI.applyCreateTime || INVALI.createTime).format('YYYY年MM月DD日')}}签订了主题名为《{{INVALI.contractName}}》的合同（以下简称“原合同”），合同编号为：{{INVALI.applyNo}}。现经签约各方协商一致，同意终止原合同并达成如下协议：</p>
  <h2>第一条 合同作废声明</h2>
  <p class="indent">以上签约方确认，自本协议签署之日起，原合同效力终止，签约各方权利义务关系解除，原合同不再对签约各方具有法律约束力。</p>
  <h2>第二条 作废原因</h2>
  <p class="indent">同意作废原合同的原因：{{cancelForm.reason ? reasonSet.find(item => item.value === cancelForm.reason).label : ''}}。</p>
  <p class="indent line-break">详细说明：{{cancelForm.reasontxt}}。</p>
  <h2>第三条 其他</h2>
  <p class="indent">1.本协议自签约各方签字或盖章之日起生效；</p>
  <p class="indent">2.未尽事宜，签约各方可另行签订补充协议。</p>
  <p v-for="(signator,i) of INVALI.signInfoVOS" :key="signator.signNo">{{`签约方${simpleChineseNumbers[i+1]}:&nbsp;&nbsp;${signator.signatoryFullName.split('-')[0] || ''}`}}</p>
</div>
</template>
<script>
import moment from 'moment'
  export default {
    props:{
      INVALI:{
        type:Object,
        default(){
          return{
            applyCreateTime:'',
            contractName:'',
            applyNo:'',
            signInfoVOS:[]
          }
        }
      },
      cancelForm:{
        type:Object,
        default(){
          return{
            reason:'',
            reasontxt:''
          }
        }
      },
      reasonSet:{
        type:Array,
        default(){
          return []
        }
      }
    },
    data () {
      // 这里存放数据
      return {
        moment,
        simpleChineseNumbers: {
          0: '零',
          1: '一',
          2: '二',
          3: '三',
          4: '四',
          5: '五',
          6: '六',
          7: '七',
          8: '八',
          9: '九',
          10: '十'
        }
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .contract-root{
    >h1{text-align: center;font-size: 1.5vw;}
    >p{
      line-height: 2;
      // margin-bottom: 1em; /* 可选：设置段落间距 */
    }
    .indent{
      text-indent: 2em;
    }
    .line-break{
      word-break: break-all;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/initiation/invalidation/components/contract.vue